import { api } from "../helper/apiClient.js";

export default async function login({ user, password }, { persist = true } = {}) {
  if (!user || !password) {
    return { ok: false, status: 0, error: "Credenciais obrigatórias (user, password)" };
  }

  const res = await api("/auth/login", {
    method: "POST",
    body: { user, password },
  });

  if (!res.ok) return res;

  if (persist && typeof sessionStorage !== "undefined") {
    try {
      sessionStorage.setItem("user", JSON.stringify(res.data));
    } catch {
      // ignore falha de storage
    }
  }

  return res;
}

export async function validarToken(token) {
  const sessionToken =
    token ??
    (() => {
      try {
        return JSON.parse(sessionStorage.getItem("user") || "null")?.token ?? null;
      } catch {
        return null;
      }
    })();

  if (!sessionToken) {
    return { ok: false, status: 0, error: "Token ausente" };
  }

  const res = await api("/auth/validate-token", {
    method: "POST",
    token: sessionToken,
  });

  if (res.ok && res.data?.user) {
    try {
      const currentStorage = JSON.parse(sessionStorage.getItem("user") || "{}");

      const updatedStorage = {
        ...currentStorage,
        ...res.data.user
      };

      sessionStorage.setItem("user", JSON.stringify(updatedStorage));
    } catch (error) {
      console.error("Erro ao atualizar dados do usuário no storage:", error);
    }
  }
  return res;
}

export async function verificarAdmin(token) {
  const sessionToken =
    token ??
    (() => {
      try {
        return JSON.parse(sessionStorage.getItem("user") || "null")?.token ?? null;
      } catch {
        return null;
      }
    })();

  if (!sessionToken) {
    return { ok: false, status: 0, error: "Token ausente" };
  }

  return api("/auth/check-admin", {
    method: "POST",
    token: sessionToken,
  });
}